import React, { ReactElement } from "react";
import "./EACheckbox.scss";
import inputsValidation from "../../../../messages/inputValidation";

interface IProps {
  name: string;
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  label?: string | ReactElement;
  field?: object;
  errors?: any;
}

const EACheckbox: React.FC<IProps> = ({ name, checked, onChange = () => {}, label, field, errors }) => {
  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.checked);
  };

  return (
    <div className="custom-checkbox__container">
      <label className="custom-checkbox__wrapper">
        <input
          name={name}
          type="checkbox"
          checked={checked}
          onChange={handleCheckboxChange}
          className="custom-checkbox__input"
          {...field}
          id={name}
        />
        {label && <p className="custom-checkbox__label no-line-height">{label}</p>}
      </label>
      {errors?.[name] && <span className="custom-checkbox__error">*{inputsValidation(errors, name)}</span>}
    </div>
  );
};

export default EACheckbox;
